import { Autocomplete, AutocompleteOption, VariantProp } from '@healthinal/ui';
import { GetPatientsBasicsType, PatientBasicsDto } from '../../api/generated/model';
import { useGetPatientsBasics } from '../../api/generated/patient-controller/patient-controller.ts';
import { FETCH_ALL_PAGE_SIZE } from '../../api/pagination.ts';
import { formatDateYear } from '../../utils/date.ts';

interface Props {
  onChange: (patientDto: PatientBasicsDto | null) => void;
  value: PatientBasicsDto | null;
  patientsType: GetPatientsBasicsType;
  activeOnly?: boolean;
  // Label the options by case number instead of name and birth year.
  showCaseNumber?: boolean;
  disabled?: boolean;
  variant?: VariantProp;
}
export function SelectPatient({ onChange, value, patientsType, activeOnly, showCaseNumber, disabled, variant }: Props) {
  const getLabel = showCaseNumber ? formatPatientCaseNumber : formatPatientNameAndBirthday;

  const { data: patientsPage, isPending } = useGetPatientsBasics({
    type: patientsType,
    activeOnly,
    assignedTo: 'ALL',
    size: FETCH_ALL_PAGE_SIZE,
  });
  const patients = patientsPage?.content ?? [];

  return (
    <Autocomplete
      value={value}
      disabled={disabled}
      onChange={(_, value) => onChange(value)}
      loading={isPending}
      options={patients ?? []}
      getOptionLabel={(option) => getLabel(option)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderOption={(props, option) => (
        <AutocompleteOption {...props} key={option.id}>
          {getLabel(option)}
        </AutocompleteOption>
      )}
      variant={variant}
    />
  );
}

function formatPatientNameAndBirthday(patient: PatientBasicsDto) {
  return `${patient.lastName} ${patient.firstName} (${formatDateYear(patient.birthDate)})`;
}

// Falls back to the name for the rare patient without a case number.
function formatPatientCaseNumber(patient: PatientBasicsDto) {
  return patient.caseNumber ?? formatPatientNameAndBirthday(patient);
}
